import { render } from "./ListePiecePage.vue?vue&type=template&id=6ff2c9d2&ts=true"
import script from "./ListePiecePage.vue?vue&type=script&lang=ts"
export * from "./ListePiecePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__